<template>
  <div class="fixed inset-0 overflow-hidden transition-all duration-100 ease-in-out" style="z-index:9999" :class="{ 'block': isOpen, 'hidden': !isOpen, }">
    <div class="absolute inset-0 bg-gray-500 opacity-50" @click="close"></div>
    <div class="absolute inset-y-0 right-0 pl-10 max-w-full flex">
      <div class="relative w-screen sm:w-auto">
        <div class="h-full bg-white overflow-y-auto max-w-lg">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    handleClickOutside(e) {
      if (this.isOpen && !this.$el.contains(e.target)) {
        this.close();
      }
    },
  },
  mounted() {

  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}
.block {
  display: block;
}
</style>